import {UserDefinedWidgetType} from '@constants/pages/user-defined-page/user-defined-widget-type';

export class UserPageGridLayoutItem {
  public x: number;
  public y: number;
  public w: number;
  public h: number;
  public id: string;
  public minW: number | undefined = undefined;
  public maxW: number | undefined = undefined;
  public minH: number | undefined = undefined;
  public maxH: number | undefined = undefined;

  constructor(id: string, x: number, y: number, w: number, h: number, name: string, type: UserDefinedWidgetType) {
    this.id = id;
    this.x = x;
    this.y = y;
    this.w = w;
    this.h = h;
    this._type = type;
    this._name = name;
  }

  private _type: UserDefinedWidgetType;

  get type(): UserDefinedWidgetType {
    return this._type;
  }

  private _name: string;

  get name(): string {
    return this._name;
  }

  withMinW(value: number): UserPageGridLayoutItem {
    this.minW = value;
    return this;
  }

  withMaxW(value: number): UserPageGridLayoutItem {
    this.maxW = value;
    return this;
  }

  withMinH(value: number): UserPageGridLayoutItem {
    this.minH = value;
    return this;
  }

  withMaxH(value: number): UserPageGridLayoutItem {
    this.maxH = value;
    return this;
  }

  changeType(value: UserDefinedWidgetType): UserPageGridLayoutItem {
    this._type = value;
    return this;
  }

  changeName(value: string): UserPageGridLayoutItem {
    this._name = value;
    return this;
  }

}
